import { render, staticRenderFns } from "./TermsBanner.vue?vue&type=template&id=5d590554"
import script from "./TermsBanner.vue?vue&type=script&lang=js"
export * from "./TermsBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports